import { generateIconComponent } from './icons.utils';

export const CheckmarkSolidIcon = generateIconComponent({
    name: 'CheckmarkSolidIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M23.6779 4.92599L22.121 3.33012C21.6916 2.88996 20.9935 2.88996 20.564 3.33012L8.88583 15.3025L3.43762 9.71586C3.00599 9.27344 2.3101 9.27344 1.88067 9.71586L0.323722 11.3117C-0.107907 11.7519 -0.107907 12.4652 0.323722 12.9076L5.77194 18.4943L8.10846 20.887C8.53788 21.3294 9.23378 21.3294 9.6654 20.887L11.9997 18.4943L23.6779 6.52186C24.1074 6.0817 24.1074 5.36616 23.6779 4.92599Z" />
    ),
});
